import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import ErrorMessage from 'components/share/ErrorMessage'
import { UsageAndAttitudeWidgetType } from '../types'

const BelowThresholdGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<UsageAndAttitudeWidgetType>(widgetId)
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  const entries = widgetData.data[0].results![0].data.insights?.flatMap(
    (insight) => insight.dataset
  )
  const values = entries!.flatMap((entry) => entry?.set).map((entry) => entry!.value!)

  if ('minCount' in widgetSetting) {
    const isBelowThreshold = values.every((value) => value < (widgetSetting.minCount || 0))

    if (isBelowThreshold) return <ErrorMessage>{t('emptyBecauseLowCount')}</ErrorMessage>
  }

  return children
}

export default BelowThresholdGuard
